class InventoryCountSearchController extends BaseSearchController
	@register()
	@inject '$stateParams',
		'statusEnum': 'BACKEND_INVENTORY_COUNT_STATUS'

	applySearchFilter: (query) ->
		super(query)

		query.sortBy 'status', 'DESC'
		query.sortBy 'timestamp', 'DESC'

		if !_.isEmpty @$stateParams.stock_location_id
			query.criteria 'stock_location_id', '=', @$stateParams.stock_location_id
